/**
 * Labstep
 *
 * @module core/Icon
 * @desc Wrapper around semantic-ui-react Icon
 */

import cx from 'classnames';
import { iconPopups } from 'labstep-web/constants/icons';
import { Link } from 'labstep-web/core/Link';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import SemanticIcon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import styles from './styles.module.scss';
import type { IconProps } from './types';

export const Icon: React.FC<IconProps> = ({
  className,
  color,
  route,
  popup,
  cornerIcon,
  cornerIconPosition = 'top right',
  ...rest
}) => {
  // White color not support by Semantic UI by default
  const classNames = cx(className, {
    [styles.white]: color === 'white',
    [styles.clickable]: !rest.disabled && rest.onClick,
  });
  const props = {
    color: color === 'white' ? undefined : color,
    'data-testid': `icon ${rest.name}`,
    'data-cy': `core/Icon:${rest.name}`,
    ...rest,
  };
  let icon = cornerIcon ? (
    <SemanticIcon.Group className={cx(styles.group, classNames)}>
      <SemanticIcon {...props} data-public />
      <SemanticIcon
        corner={cornerIconPosition}
        name={cornerIcon}
        data-public
      />
    </SemanticIcon.Group>
  ) : (
    <SemanticIcon className={classNames} {...props} data-public />
  );
  if (route) {
    icon = (
      <Link {...route} unstyled data-public>
        {icon}
      </Link>
    );
  }
  const iconWithPopup = rest.name as keyof typeof iconPopups;
  if (popup && (popup.content || iconPopups[iconWithPopup])) {
    icon = (
      <Popup
        content={popup.content || iconPopups[iconWithPopup]}
        inverted
        size="mini"
        trigger={icon}
        {...popup}
      />
    );
  }
  return icon;
};
